import { useEffect } from "react";
import "@/App.css";
import { initLenis } from "./lib/scroll";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Hero from "./sections/Hero";
import Problem from "./sections/Problem";
import Solution from "./sections/Solution";
import Audience from "./sections/Audience";
import Services from "./sections/Services";
import About from "./sections/About";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";

function App() {
  useEffect(() => initLenis(), []);

  return (
    <div className="App relative min-h-screen bg-[#0B0812] text-slate-300">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <Audience />
        <Services />
        <About />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" richColors position="bottom-right" />
    </div>
  );
}

export default App;
